import React from 'react';
import { FormattedHTMLMessage, injectIntl } from 'react-intl';
import {
    FormSelectChoice,
    FormFieldComponentProps,
    VerificationServiceProps,
    Country,
    getSafe,
    getOptions,
    TypeaheadComponent
} from '@sheerid/jslib';


export const MedicalProfessionalOrganization = ({
    onChange,
    value,
    isErrored,
    verificationService,
    intl,
    placeholder = '',
}: FormFieldComponentProps & VerificationServiceProps) => {
    const { programId } = verificationService;
    const id = 'sid-medical-professional-organization';

    return (
        <div className="sid-field sid-medical-professional-organization-id">
            <div className="sid-l-space-top-md" />
            <label htmlFor={id} id="sid-medical-organization-label">
                <div id={`${id}-label`} className="sid-field__label sid-field__label--required sid-l-space-btm-sm">
                    <FormattedHTMLMessage
                        id="organization"
                        defaultMessage="Organization"
                    />
                </div>
            </label>
            <TypeaheadComponent
                className={isErrored ? 'sid-text-input--error' : ''}
                countryCode={getSafe<Country>(() => verificationService.viewModel.countryChoice.value)}
                minimumSearchValueLength={getOptions().minimumOrganizationSearchLength}
                onChange={(choice: FormSelectChoice) => onChange(choice)}
                placeholder={placeholder || (intl as any).formatMessage({ id: 'organizationPlaceholder', defaultMessage: 'Organization*' })}
                programId={programId}
                value={value}
                inputHtmlId={id}
                aria-labelledby="sid-medical-organization-label"
                aria-required={true}
                openOrgSearchEnabled={verificationService.programTheme.openOrgSearchEnabled}
                orgSearchUrl={verificationService.programTheme.config.orgSearchUrl}
                isRequired
            />
            {
                isErrored ? (
                    <div className="sid-field-error">
                        <FormattedHTMLMessage
                            id="errorId.invalidOrganization"
                            defaultMessage="You must select an organization from the list"
                        />
                    </div>
                ) : null
            }
        </div>
    );
};

export const MedicalProfessionalOrganizationComponent = injectIntl(MedicalProfessionalOrganization);
